/* eslint-disable */
<template>
  <div class="manage-user">
    <AdminNavigation ref="navigation" indexProps="3"/>
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>{{
            singleUser.PracticeManagerID ? 'Edit Practice Manager ' + (singleUser.FirstName + ' ' + singleUser.Surname) : 'Create Practice Manager'
          }}</h1></div>
<!--        <div class="header-sub-title">Users are required to keep track of data ownership, whether the user can login or not. Only add 'user login' where the person will authenticate into the application.</div>-->
      </div>
    </div>
    <div class="panel">
      <AdminSpecialistMenu :key="specialistMenuIndex" :indexProps="specialistMenuIndex"/>
      <div class="content d-flex" >
        <div style="flex: 1">
          <div class="box">
            <div class="box-heading"><span>Practice Manager Details</span></div>
            <div class="box-body">
              <div class="box-row">
                <div class="box-col box-col-left required">First Name</div>
                <div class="box-col box-col-right">
                  <el-input type="text" v-model="singleUser.FirstName" placeholder="First Name"
                            @blur="trimField('FirstName')" />
                  <div v-if="hasError && firstNameError" class="text-danger">{{ firstNameError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left required">Surname</div>
                <div class="box-col box-col-right">
                  <el-input type="text" v-model="singleUser.Surname" placeholder="Surname"
                            @blur="trimField('Surname')" />
                  <div v-if="hasError && surnameError" class="text-danger">{{ surnameError }}</div>
                </div>
              </div>
              <div class="box-row" >
                <div class="box-col box-col-left required">Email</div>
                <div class="box-col box-col-right">
                  <el-input type="text" v-model="singleUser.EmailAddress"
                            placeholder="Please enter the user’s email address - this will be used to login"
                            @blur="trimField('EmailAddress')" />
                  <div v-if="hasError && emailError" class="text-danger">{{ emailError }}</div>
                </div>
              </div>
              <div class="box-row" >
                <div class="box-col box-col-left">Notification Email</div>
                <div class="box-col box-col-right">
                  <el-input type="text" v-model="singleUser.NotificationEmailAddress"
                            placeholder="Optional — notifications will use this address if set"
                            @blur="trimField('NotificationEmailAddress')" />
                  <div v-if="hasError && notificationEmailError" class="text-danger">{{ notificationEmailError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left required">Mobile</div>
                <div class="box-col box-col-right">
                  <el-input type="text" class="w-50" v-model="singleUser.Mobile"
                            placeholder="+61 followed by 9 digits (12 characters)"
                            @blur="normalizeMobileField" />
                  <div class="text-danger" v-if="hasError && mobileError">{{ mobileError }}</div>
                </div>
              </div>
              <div class="box-row" >
                <div class="box-col box-col-left required">Specialist</div>
                <div class="box-col box-col-right">
                  <el-select v-model="clients" placeholder="Select specialist" class="w-100 form-select"  filterable multiple
                             clearable>
                    <el-option v-for="(specialist, index) in specialists" :key="index" :value="specialist.id"
                               :label="specialist.fullName">{{specialist.fullName}}
                    </el-option>
                  </el-select>
                  <div class="text-danger" v-if="(hasError && !validateSpecialist)">Please select at least one specialist</div>
                </div>
              </div>
              <div v-if="singleUser.PracticeManagerID" class="box-row" >
                <div class="box-col box-col-left">Active</div>
                <div class="box-col box-col-right row-item">
                  <input type="checkbox" :checked="!!singleUser.Active"  @change="onChangeActive" />
                  <v-btn v-if="showResend" class="ml-10 col-center-content"
                         style="background-color:#C4C4C4;color:#6686B6F" @click="reSendInvitation()"> Resend Invite
                  </v-btn>
                </div>
              </div>
            </div>

          </div>
          <div class="icon-group right-float-element">
            <v-btn dark @click="save">Save</v-btn>
          </div>
        </div>
        <div style="max-width: 300px; position: relative">
          <Timeline :timeline="timeLines"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSpecialistMenu from '@/components/AdminSpecialistMenu'
import Header from '@/components/Header'
import Timeline from '@/components/Timeline'

export default {
  name: 'AdminManagePracticeManager',
  components: {
    AdminNavigation,
    AdminSpecialistMenu,
    Header,
    Timeline
  },
  data() {
    return {
      showResend: false,
      specialistMenuIndex: 3,
      hasError: false,
      successMessage: "",
      errorMessage: "Please correct the errors shown above and try again.",
      loaded: false,
      timeLines: [],
      singleUser: {
        FirstName: null,
        Surname: null,
        Mobile: null,
        EmailAddress: null,
        LocationID: null,
        NotificationEmailAddress: null,
        SpecialistIDs: []
      },
      locations: [],
      specialists: [],
      clients: [],
      users: [],
      userParam: {
        pageNum: 1,
        pageSize: 10,
        EmailAddress: null
      },
    }
  },
  watch: {
    singleUser: {
      handler(value) {
        if (this.loaded) this.$store.dispatch('setNewObject', value)
      },
      deep: true,
    },
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
    /**
     * Excel spec: First name 1–100 chars — English letters, space, hyphen, apostrophe (same as client contact person name).
     */
    firstNameError() {
      return utilities.getClientContactPersonNameError(this.singleUser.FirstName, 'First name')
    },
    surnameError() {
      return utilities.getClientContactPersonNameError(this.singleUser.Surname, 'Surname')
    },
    /**
     * Excel spec: Email 1–100 chars — allowed charset + standard email (same as client contact email).
     */
    emailError() {
      return utilities.getClientContactEmailError(this.singleUser.EmailAddress, 'Email', true)
    },
    /**
     * Optional; when set, same rules as main email.
     */
    notificationEmailError() {
      return utilities.getClientContactEmailError(this.singleUser.NotificationEmailAddress, 'Notification email', false)
    },
    /**
     * Excel spec: Mobile exactly 12 characters (+61 + 9 digits).
     */
    mobileError() {
      const normalized = utilities.normalizeAuPhoneInput(this.singleUser.Mobile)
      if (!normalized) {
        return 'Mobile is required.'
      }
      return utilities.getClientContactPhoneAu12Error(normalized, 'Mobile')
    },
    validateSpecialist() {
      return this.clients.length > 0
    },
  },
  methods: {
    trimField(prop) {
      const v = this.singleUser[prop]
      if (v === undefined || v === null) {
        return
      }
      this.singleUser[prop] = String(v).trim()
    },
    normalizeMobileField() {
      this.singleUser.Mobile = utilities.normalizeAuPhoneInput(this.singleUser.Mobile)
    },
    sanitizeBeforeValidate() {
      this.trimField('FirstName')
      this.trimField('Surname')
      this.trimField('EmailAddress')
      this.trimField('NotificationEmailAddress')
      this.singleUser.Mobile = utilities.normalizeAuPhoneInput(this.singleUser.Mobile)
    },
    async reSendInvitation() {
      this.sanitizeBeforeValidate()
      if (this.mobileError) {
        this.hasError = true
        return
      }

      var mobile = utilities.updateMobileCode(utilities.validatePhonenumber(this.singleUser.Mobile))
      if (mobile.charAt(0) == '0') {
        mobile = mobile.substring(1)
      }
      await this.$store.dispatch('loading/setLoadComponent', true)
      var params = {
        Name: this.singleUser.FirstName + ' ' + this.singleUser.Surname,
        EmailAddress: this.singleUser.EmailAddress,
        Mobile: mobile,
        UserRoleID: 7,
      }
      var result = await utilities.postResendInvite(this.singleUser.UserID, params)
      if (result) {
        this.$notify({
          message: '<div class="alert-success">' +
              '            <b>Success:</b> Invitation Resent!' +
              '          </div>',
          dangerouslyUseHTMLString: true,
          duration: 10000
        });
      }
      await this.$store.dispatch('loading/setLoadComponent', false)
    },
    async onChangeActive(e) {
      this.singleUser.Active = e.target.checked ? 1 : 0;
      await this.onChangeUserActive()
      await this.loadData();
    },

    async onChangeUserActive() {
      await this.$store.dispatch('loading/setLoadComponent', true)
      await utilities.putPracticeManagerActive(this.singleUser.PracticeManagerID, this.singleUser.Active)
      await this.$store.dispatch('loading/setLoadComponent', false)
    },

    async save() {
      this.sanitizeBeforeValidate()
      const specialistOk = this.validateSpecialist
      if (this.firstNameError || this.surnameError || this.emailError || this.notificationEmailError || this.mobileError || !specialistOk) {
        this.hasError = true
        utilities.showAlert(".alert-danger")
        return false
      }
      this.hasError = false

      const param ={
        FirstName: this.singleUser.FirstName,
        Surname: this.singleUser.Surname,
        Mobile: utilities.updateMobileCode(utilities.validatePhonenumber(this.singleUser.Mobile)),
        EmailAddress: this.singleUser.EmailAddress,
        SpecialistIDs: this.clients,
      }
      if(this.singleUser.NotificationEmailAddress) {
        param.NotificationEmailAddress = this.singleUser.NotificationEmailAddress
      }
      if(this.singleUser.LocationID) {
        param.LocationID = this.singleUser.LocationID
      }
      await this.$store.dispatch('loading/setLoadComponent', true)
      try {
        if (this.singleUser.PracticeManagerID) {
          param.Active = this.singleUser.Active
          await utilities.putPracticeManager(this.singleUser.PracticeManagerID, param)
        } else {
          await utilities.postPracticeManager(param)
        }
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<div class="alert-success">' +
              '            <b>Success:</b> Changes Updated!' +
              '          </div>',
        });
        await this.$store.dispatch('setOriginalObject', null)
        await this.$store.dispatch('setNewObject', null)
        this.$router.go(-1);
      } finally {
        await this.$store.dispatch('loading/setLoadComponent', false)
      }
    },


    async loadData() {
      const arr = [utilities.getSpecialists(), utilities.getLocations()]
      if(this.$route.query.id) {
        this.singleUser.PracticeManagerID = this.$route.query.id
        arr.push(utilities.getPractiseManagerDetail(this.$route.query.id))
        arr.push(utilities.getPracticeManagerLogs(this.$route.query.id))
      }
      const res = await Promise.all(arr)
      this.specialists = res[0]
      this.locations = res[1]
      if(this.$route.query.id) {
        this.singleUser = res[2]
        if (this.singleUser.Active) {
          this.showResend = true
        } else {
          this.showResend = false
        }
        this.clients = this.singleUser.Specialists.map((item) => item.SpecialistID)
        const r = res[3]
        var timeline = {};
        r.map((x) => {
          timeline = {
            id: x.PracticeManagerID,
            userName: x.Username,
            datetime: utilities.formatDate(x.LogDate, "DD/MM/YYYY hh:ss A", "YYYY-MM-DD HH:mm:ss.ssssss"),
            body: x.LogDetails,
          };
          this.timeLines.push(timeline);
        });
      }
      await this.$store.dispatch('setOriginalObject', this.singleUser)
      await this.$store.dispatch('setNewObject', this.singleUser)
    }

  },
  async beforeMount() {
    await this.$store.dispatch('loading/setLoadComponent', true)
    await this.loadData()
    this.loaded = true
    await this.$store.dispatch('loading/setLoadComponent', false)
  }
}
</script>
